"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JamoConstants_1 = require("../JamoConstants");
function isJamo(inputKey) {
    return (inputKey.length === 1 &&
        (JamoConstants_1.JamoConstants.consonants.includes(inputKey) ||
            JamoConstants_1.JamoConstants.vowels.includes(inputKey)));
}
exports.default = isJamo;
